/* EditAction.js */

"use strict";
const _ = require("lodash");

class EditAction {
    constructor(logger, gameEditor, activeView, steveIo) {
        this._logger = logger;
        this._activeView = activeView;
        this._fileFactory = steveIo.fileFactory;
        this._gameEditor = gameEditor;
        this.run = this.run.bind(this);
    }
    run() {
        return Promise.resolve().then(() => {
            let selectedPlanIds = _.get(
                this._activeView.getSelectedOdmOsPlatformIds(),
                "selectedRows",
                []
            );
            this._activeView.openPlatformInstanceEditor(selectedPlanIds);
        });
    }
}
module.exports = EditAction;

EditAction.$inject = ["$teve.logger", "gameEditor.gameEditor", "gameEditor.activeView", "$teve.io"];

EditAction.$displayDetails = {
    type: "Action",
    name: "EditAction",
    icon: "osmanager.odm_os_platform_edit",
    shown: true,
    title: "Edit IoT Platform",
    order: 2,
};
